// Dettagli piano e UDP per il caricamento ajax delle voci
function loadItemProjects() {
    const items = $('.load-item-project');
    $.each(items, function (i, item) {
        $(item).on('click', function () {
            const parent = $(this).closest('tr')
            let sibling = parent.siblings('.content-for-' + $(this).data("item-id"))
            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
                sibling?.addClass('hidden')
                $(this).html('<i class="fa-solid fa-circle-chevron-down"></i>');
            } else {
                if (sibling.length === 0) {
                    parent.after('<tr class="content-for-' + $(this).data('item-id') + '"><td style="padding: 0;" colspan="100"></td></tr>')
                    sibling = parent.siblings('.content-for-' + $(this).data("item-id"))
                }
                $(this).addClass('active')
                sibling?.removeClass('hidden')
                $(this).html('<i class="fa-solid fa-circle-chevron-up"></i>');
                $.ajax({
                    url: $(this).data('item-url'),
                    success: function (data) {
                        sibling.find('td').html(data)
                    }
                });
            }

        })
    })
}

// SELEZIONA TUTTI GLI ELEMENTI DELLA SELECT, form new/edit UDP
function udpSelectAll() {
    $('#udp_document_type_ids').on('select2:select', function (e) {
        // console.log(e.params.data)
        if (e.params.data.id === '') {
            // Seleziona tutte le opzioni eccetto "Seleziona Tutto"
            let allOptions = $('#udp_document_type_ids option:not([value=""])').map(function () {
                return $(this).val();
            }).get();

            // console.log(allOptions)
            $('#udp_document_type_ids').val(allOptions).trigger('change');
        }
    })
}

// change event UDP, form journal_entry
function initChangeUDP() {
    const $element = $('form.journal_entry #journal_entry_udp_id')
    const $documentTypeSelect = $('form.journal_entry #journal_entry_document_type_id')
    const isChiusuraCassa = $element.closest("form").hasClass('form_chiusura_cassa')

    $element.on('change', function (e) {
        const optionSelected = $("option:selected", this);
        const currentValue = $(this).val();
        const identifier = (optionSelected.data('identifier'))
        const $containers = $('fieldset.amount-share')

        $.getJSON(`/admin/journal_entries/document_types?udp_id=${this.value}&isChiusuraCassa=${isChiusuraCassa}`, function (data) {
            const autoSelect = data.length === 1
            const alreadySelected = parseInt($documentTypeSelect.find('option:selected')?.val());
            $documentTypeSelect.find('option').remove()
            const newOption = new Option(" ", '', false, false);
            !autoSelect && $documentTypeSelect.append(newOption);
            $.each(data, function (i, d) {
                const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
                d[2] && newOption.setAttribute("data-identifier", d[2]['data-identifier'])
                $documentTypeSelect.append(newOption);
            })
            $documentTypeSelect.trigger('change');

            if ($containers.length === 1) {
                $.each($containers, function (i, container) {
                    const $container = $(container);
                    const selectUdp = $container.find(`[id^=journal_entry_amount_shares_attributes_][id$=udp_id]`)
                    selectUdp.val(currentValue)
                    selectUdp.trigger('change');
                })
            }

        });
    });

}


export { loadItemProjects, udpSelectAll, initChangeUDP }